<template>
    <vs-sidebar
        v-model="isActive"
        class="items-no-padding"
        parent="#expenses-app"
        v-on="$listeners"
        v-bind="$attrs"
        ref="sidebar"
    >
        <vx-main-sidebar :menu-routes="menuRoutes" />
    </vs-sidebar>
</template>

<script>
export default {
    name: 'patients-sidemenu',
    props: {
        value: {
            type: Boolean,
            default: true
        }
    },
    computed: {
        isActive: {
            get() {
                return this.value
            },
            set(v) {
                this.$emit('input', v)
            }
        },
        menuRoutes() {
            return {
                'Patient Information': [/*'user-profile',*/ 'patients-directory']
            }
        }
    }
}
</script>
